import { render, staticRenderFns } from "./PhieuDieuTourForm.vue?vue&type=template&id=247fd44c&"
import script from "./PhieuDieuTourForm.vue?vue&type=script&lang=js&"
export * from "./PhieuDieuTourForm.vue?vue&type=script&lang=js&"
import style0 from "./PhieuDieuTourForm.vue?vue&type=style&index=0&id=247fd44c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports